var _path, _path2, _path3, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.886,32.349h1.543c2.207,0,3.995-1.789,3.995-3.995V7.594c0-2.207-1.789-3.996-3.995-3.996H12.571c-2.207,0-3.996,1.789-3.996,3.996v20.76c0,2.207,1.789,3.995,3.996,3.995h1.543l-7.263,6.053h4.964l7.263-6.053h3.845l7.263,6.053h4.964l-7.263-6.053Zm-13.833-13.3c-1.344,0-2.434-1.09-2.434-2.434v-4.848c0-1.344,1.09-2.434,2.434-2.434h13.928c1.344,0,2.434,1.09,2.434,2.434v4.848c0,1.344-1.09,2.434-2.434,2.434h-13.928Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.872,29.62c-1.254,0-2.27-1.016-2.27-2.27s1.016-2.27,2.27-2.27,2.27,1.016,2.27,2.27-1.016,2.27-2.27,2.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.858,27.35c0-1.254,1.016-2.27,2.27-2.27s2.27,1.016,2.27,2.27-1.016,2.27-2.27,2.27-2.27-1.016-2.27-2.27Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.114,
    y1: 32.349,
    x2: 29.429,
    y2: 32.349
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16.91,
    y1: 6.471,
    x2: 25.012,
    y2: 6.471
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorTrain);
export default __webpack_public_path__ + "static/media/indoor-train.bf25bb3cd6901db75d8668abec500286.svg";
export { ForwardRef as ReactComponent };